<app-header></app-header>
<main class="pages healthcare">
    <!-- Hero Section -->
    <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <h1 alt="hospital related survey" class="h1-title mt-3">Improve Healthcare services to ensure safety standards are maintained</h1>
                    <p class="sub-text mt-3">Conduct White-label Patient Experience survey and get real-time data analytics about what they think about your services. Improve Healthcare with the help of meaningful reports generated through CViewSurvey App.</p>
                    <div class="mt-lg-5 mt-0">
                        <a title="" class="btn btn-lg btn-success px-4 text-uppercase  mr-lg-2" data-toggle="modal" data-target="#callBack" id="callback"> Request a Demo</a>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid w-100" alt="Healthcare Survey" src="assets/healthcare.svg">
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--End Hero Section -->

    <!-- Main Page Section -->
    <section class="mb-5 pb-5">
        <div class="container">
            <div class="col-md-12">
                <div class="featured video card border-0 shadow mt-lg-5">
                    <div class="card-body">
                        <h2 alt="get feedback for hospital" class="h2-title text-center headings mb-4">Healthcare</h2>
                        <p class="text-center sub-text text-justify">CView Healthcare survey app for Hospital, Clinics, Pharmacies and labs makes you capture patient sentiments, staff responsiveness, facility rating and overall patient and staff satisfaction. It is a platform that gives a 360<sup>&deg;</sup>                            estimation of your services, and helps improve them for a better patient and staff experience. It lets you capture feedback on mobiles and tablets, through online or offline mode, thereby ensuring smooth functioning of the
                            healthcare center.
                        </p>
                        <!-- play-video -->
                        <div class="play-video">
                            <a class="video-play-button" (click)="scroll(target)">
                                <span></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="mt-lg-5 mb-lg-5  pt-lg-5 pb-lg-5">
        <div class="container mb-lg-5 ">
            <h3 alt="patient satisfaction survey in healthcare" class="text-center" class="features-main-heading">Perks of using our Healthcare Surveys:</h3>
        </div>

        <div class="features-screenshot-right ">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid px-lg-5 mb-3 mb-lg-0" alt="Healthcare Patient Satisfaction Survey" src="assets/mouth-publicity.svg">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <h4 class="feature-heading text-capitalize">HELPS YOU IDENTIFY YOUR STRENGTHS</h4>
                        <p class="sub-text text-justify">
                            By conducting our hospital feedback and patient satisfaction surveys, you can know what your patients and staff think about your healthcare services. This can be measured using special question types in NPS<sup>&reg;</sup>,
                            CSAT and CES templates thus allowing you to improve your services.
                        </p>
                        <h4 class="feature-heading mt-4">POSITIVE RECOMMENDATIONS</h4>
                        <p class="sub-text text-justify">By recognizing the requirements of your patients and staff from the responses collected and working on it, you create a healthy and satisfying environment. This leaves a positive impact on your patients and staff members which
                            ensures positive recommendation in terms of healthcare services from them.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="features-screenshot-left">
            <div class="container">
                <div class="row align-items-center mob-column-reverse">
                    <div class="col-md-6">
                        <h4 class="feature-heading">C.A.A.G. STRUCTURE FOR BETTER UNDERSTANDING</h4>
                        <p class="sub-text text-justify">
                            Conducting medical, hospital patient or hospital satisfaction surveys helps you identify scope of improvement. By identifying those areas correctly and working upon it, you can enhance the quality of your services and staff experience which will reflect
                            in your revenue generation as well.
                        </p>
                        <h4 class="feature-heading mt-4">ALLOWS YOU TO TAKE PERSONALIZED ACTIONS</h4>
                        <p class="sub-text text-justify">Knowing about the preferences and issues of your patients and staff, you can add our logic feature to your surveys which will bifurcate the survey according to your respondents answers. This will allow you to make better informed
                            decisions and actions.</p>
                    </div>
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid px-lg-5 mb-3 mb-lg-0" alt="Healthcare survey" src="assets/revenue.svg">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="features-screenshot-right ">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div class="lazy-image-wrapper loaded">
                            <img class="img-fluid px-lg-5 mb-3 mb-lg-0" alt="Healthcare Patient Satisfaction Survey" src="assets/patient-relationship.svg">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <h4 class="feature-heading">BUILDS HEALTHY RELATIONSHIP WITH PATIENT</h4>
                        <p class="sub-text text-justify">Conducting patient satisfaction and hospital satisfaction surveys gives your patients and staff an impression of being heard. By identifying and quickly resolving the issues brought forward sends a strong message. This builds a
                            healthy relationship between your organization and patient.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="container text-center my-5">
            <p class="sub-text">

            </p>
        </div>
    </section>
    <!-- Main Page Section -->

    <!-- video-section -->
    <section #target class="bg-primary py-lg-5 mt-lg-5 position-relative">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="solution-video">
                        <iframe width="580" height="335" [src]="safeURL" frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
<app-footer></app-footer>